
export default {
  name: 'IconDocument',
}
